export default {"src":"/_next/static/media/rejected-loan.5894ccc4.svg","height":188,"width":300,"blurWidth":0,"blurHeight":0};